<div class="row">

    <div class="col-md-12 col-lg-12 col-sm-12 col-xs-12 text-center">

        <button *ngIf="!hideFileRelatedOptions" type="button" class="btn btn-sm btn-choose-file"
            (click)="fileUploaderButton?.click()">
            <i class="fa fa-files-o" aria-hidden="true"></i>
            Choose file(s)
        </button>        

        <span class="hide-input-button">
        <input 
            #fileUploaderButton
            type="file" 
            name="blobFileUpload"
            multiple 
            (change)="selectFiles($event)" />
        </span>                       
    </div>

    <div class="col-md-12 col-lg-12 col-sm-12 col-xs-12 text-center">
        <small class="text-muted">
            Upload path : {{'/'+homeParams?.containerName+'/'+homeParams?.currentPath+homeParams?.newFolderName}}            
        </small>
    </div>

    <div *ngIf="selectedFiles.length > 0" class="col-md-12 col-lg-12 col-sm-12 col-xs-12">
        <div class="card">

            <div class="card-header text-center" style="padding: 2px;">
                Uploaded file(s)
            </div>
            
            <div class="card-body mat-card-content">
                <ul class="list-group list-group-flush" style="max-height: 75px;">
                    <li 
                        *ngFor="let file of selectedFiles;let i = index;" 
                        style="padding: 2px;" 
                        class="list-group-item">
                        <div class="row">

                            <div class="col-lg-9 col-md-12 col-sm-12 col-xs-12" style="white-space: nowrap;"
                                 title="{{file?.name}}">
                                {{file?.name?.length > 40 ? file?.name.slice(0,40) + '...'  : file?.name}} 
                                <small class="text-muted font-weight-bold">({{blobService?.formatBytes(file?.size)}})</small>
                                <i *ngIf="file?.progress == 0 || (file?.progress == 100 ? (file?.isUploaded && file?.isError) : false)" 
                                    (click)="remove(i,file?.size)" 
                                    class="cursor_icon trash fa fa-trash ml-1" aria-hidden="true" title="Remove"></i>
                            </div>        

                            <div class="col-lg-3 col-md-12 col-sm-12 col-xs-12">

                                <ng-container *ngIf="file?.isReady">                           
                                    <mat-progress-spinner
                                        class="uploading"
                                        [mode]="mode"
                                        [color]="primary"
                                        [diameter]="diameter"
                                    >
                                    </mat-progress-spinner>
                                </ng-container>

                                <div *ngIf="file?.isUploading && !file?.isReady" class="progress position-relative" style="margin-bottom: 0;">
                                    <div class="progress-bar" role="progressbar" [ngStyle]="{ 'width': file.progress + '%' }"></div>
                                    <large class="justify-content-center d-flex position-absolute w-100" style="color: #121111;font-weight: bolder;">
                                        {{file?.progress+'%'}}
                                    </large>
                                </div>                             

                                <ng-container *ngIf="file?.isSuccess">
                                    <i class="cursor_icon success fa fa-check-circle" aria-hidden="true" title="Success"></i>
                                </ng-container>

                                <ng-container *ngIf="file?.isError">
                                    <i class="cursor_icon error fa fa-times-circle" aria-hidden="true" title="{{file?.errorMessage}}"></i>
                                </ng-container>

                            </div>
                        </div>
                    </li>
                </ul>
            </div>

            <div class="card-footer" style="padding: 2px;">
                <div class="row">

                    <div class="col-lg-6 col-md-12 col-sm-12 col-xs-12 text-lg-left text-center">
                        <small class="ml-lg-3 font-weight-bold">Total size : {{blobService?.formatBytes(totalFileSize)}}</small>
                    </div>

                    <div class="col-lg-6 col-md-12 col-sm-12 col-xs-12 text-lg-right text-center">
                        <small class="mr-lg-3 font-weight-bold">Result : {{uploadedFilesLength}} out of {{selectedFiles?.length}} file(s) uploaded.</small><br>
                    </div>

                </div>
            </div>
            
        </div>   
    </div>

    <div *ngIf="selectedFiles?.length > 0" class="col-md-12 col-lg-12 col-sm-12 col-xs-12 text-lg-right text-center">

        <button *ngIf="hideFileRelatedOptions" type="button" class="btn btn-sm btn-outline-primary mt-1"
                (click)="downloadFileDetails()" [disabled]="!uploadedAllFiles">
                <i class="fa fa-download" aria-hidden="true"></i>
            Download Result
        </button>

        <button *ngIf="!hideFileRelatedOptions" type="button" class="btn btn-sm btn-outline-primary mt-1"
                (click)="saveFileDetails($event)" [disabled]="!selectedFiles">
                <i class="fa fa-upload" aria-hidden="true"></i>
            Upload
        </button>

    </div>

</div>